"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPartToJSON = exports.DayPartFromJSONTyped = exports.DayPartFromJSON = exports.instanceOfDayPart = exports.DayPartDayOfWeekEnum = void 0;
var runtime_1 = require("../runtime");
var DayPartHourOfDayInner_1 = require("./DayPartHourOfDayInner");
/**
 * @export
 */
exports.DayPartDayOfWeekEnum = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY'
};
/**
 * Check if a given object implements the DayPart interface.
 */
function instanceOfDayPart(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDayPart = instanceOfDayPart;
function DayPartFromJSON(json) {
    return DayPartFromJSONTyped(json, false);
}
exports.DayPartFromJSON = DayPartFromJSON;
function DayPartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dayOfWeek': !(0, runtime_1.exists)(json, 'day_of_week') ? undefined : json['day_of_week'],
        'hourOfDay': !(0, runtime_1.exists)(json, 'hour_of_day') ? undefined : (json['hour_of_day'].map(DayPartHourOfDayInner_1.DayPartHourOfDayInnerFromJSON)),
    };
}
exports.DayPartFromJSONTyped = DayPartFromJSONTyped;
function DayPartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day_of_week': value.dayOfWeek,
        'hour_of_day': value.hourOfDay === undefined ? undefined : (value.hourOfDay.map(DayPartHourOfDayInner_1.DayPartHourOfDayInnerToJSON)),
    };
}
exports.DayPartToJSON = DayPartToJSON;
